// extracted by mini-css-extract-plugin
export default {"search_input":"searchInput_search_input__dzWeh","input":"searchInput_input__8BPYA","icon":"searchInput_icon__R7uEl"};